module.exports = __webpack_public_path__ + "media/images/lb/496-ef18579786e80839cf9d36973311fb77.svg";